import React from "react";
import { Table } from "antd";

const PrintableReport = React.forwardRef(({ results, columns, reportName, printHeader, inputValues }, ref) => {
    // If there are no results, we still render the outer div so the ref can be attached,
    // but the div will be empty and won't be printed.
    if (!results || results.length === 0) {
        return <div ref={ref}></div>;
    }
    // Build title with report name and input values
    let fullTitle = reportName || '';
    if (inputValues && inputValues.length > 0) {
        fullTitle += ' ' + inputValues.filter(v => v).join(' ');
    }

    return (
        <div ref={ref} style={{ padding: "20px", background: "white" }}>
            {printHeader && <div dangerouslySetInnerHTML={{ __html: printHeader }} />}
            <h2 style={{ textAlign: "center", fontSize: "18px", marginBottom: "20px" }}>{fullTitle}</h2>
            <Table
                dataSource={results}
                columns={columns}
                pagination={false}
                rowKey={(record, index) => `print-${index}`}
                size="small"
                bordered
            />
        </div>
    );
});

export default PrintableReport;